export default {"src":"/_next/static/media/ico_buy.6ece0822.svg","height":20,"width":20};